<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMapGetter } from 'dashboard/composables/store';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import { useI18n } from 'vue-i18n';

import semver from 'semver';

const { t } = useI18n();
const { currentAccount } = useAccount();

const latestChatwootVersion = computed(() => {
  return currentAccount.value.latest_chatwoot_version;
});

const globalConfig = useMapGetter('globalConfig/get');

const hasAnUpdateAvailable = computed(() => {
  if (!semver.valid(latestChatwootVersion.value)) {
    return false;
  }

  return semver.lt(globalConfig.value.appVersion, latestChatwootVersion.value);
});

const gitSha = computed(() => {
  return globalConfig.value.gitSha.substring(0, 7);
});

const releaseNotesUrl = 'https://fazer.ai/chatwoot-release-notes';

const copyGitSha = () => {
  copyTextToClipboard(globalConfig.value.gitSha);
};
</script>

<template>
  <div class="p-4 text-sm text-center">
    <div
      v-if="globalConfig.displayManifest"
      class="mb-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-n-slate-11"
    >
      <span>
        {{ t('GENERAL_SETTINGS.BUILD_INFO.CURRENT_VERSION') }}
        <strong>{{ `v${globalConfig.appVersion}` }}</strong>
      </span>
      <span v-if="hasAnUpdateAvailable">
        {{ t('GENERAL_SETTINGS.BUILD_INFO.AVAILABLE_VERSION') }}
        <strong>{{ `v${latestChatwootVersion}` }}</strong>
      </span>
      <a
        v-if="hasAnUpdateAvailable"
        :href="releaseNotesUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="font-medium text-n-brand hover:underline"
      >
        {{ t('GENERAL_SETTINGS.BUILD_INFO.VIEW_RELEASE_NOTES') }}
      </a>
    </div>
    <div class="divide-x divide-n-slate-9">
      <span class="px-2">{{ `v${globalConfig.appVersion}` }}</span>
      <span
        v-tooltip="t('COMPONENTS.CODE.BUTTON_TEXT')"
        class="px-2 build-id cursor-pointer"
        @click="copyGitSha"
      >
        {{ `Build ${gitSha}` }}
      </span>
      <!-- eslint-disable vue/no-bare-strings-in-template @intlify/vue-i18n/no-raw-text -->
      <a
        v-if="globalConfig.displayManifest"
        href="https://fazer.ai/chatwoot-release-notes"
        target="_blank"
        rel="noopener noreferrer"
        class="px-2 text-n-slate-11 hover:text-n-brand"
      >
        Chat Fystec
      </a>
      <!-- eslint-enable vue/no-bare-strings-in-template @intlify/vue-i18n/no-raw-text -->
    </div>
  </div>
</template>
